// Encrypt key for MAL user id
export const MAL_USER_KEY = '95eab4b0-f7d7-4520-8476-61374a0022b0';
